




















































import {
  computed,
  defineComponent, PropType, useContext,
} from '@nuxtjs/composition-api';

import { SimpleImage } from '~/components/common/SimpleImage';
import ProductTile from '~/components/ProductTile/ProductTile.vue';
import { useMagentoConfiguration, useTax } from '~/composables';
import { getProductPath, isGenuine } from '~/helpers/productHelpers';
import { AlternativeProductInterface } from '~/modules/GraphQL/types';

export default defineComponent({
  name: 'ProductCrossSelling',
  components: {
    SimpleImage,
    ProductTile,
  },
  props: {
    altProduct: {
      type: [Object, null] as PropType<AlternativeProductInterface | null>,
      default: null,
    },
    isCurrentGenuine: {
      type: Boolean,
    },
  },

  setup(props) {
    const { app } = useContext();
    const { taxState, vatLabel, rawPriceCalculation } = useTax();
    const { getPriceWithCurrency } = useMagentoConfiguration();
    const price = computed(() => rawPriceCalculation(props?.altProduct?.price?.minimalPrice?.amount?.value));
    const isProductGenuine = computed(() => isGenuine(props.altProduct));
    const productType = computed(() => (isProductGenuine.value ? 'original' : 'compatible'));
    const title = computed(() => {
      if (!props.altProduct.manufacturer_anchor) {
        return props.altProduct.name;
      }

      if (!isProductGenuine.value) {
        return 'Cartridge Save Premium alternative';
      }

      const manufacturerAnchor = props.altProduct.manufacturer_anchor
        ? props.altProduct.manufacturer_anchor.replace('Genuine', 'Original')
        : '';

      return `${manufacturerAnchor} available`;
    });
    const isAllowedRule = computed(() => [1, 2, 3].includes(props.altProduct.arrow_rule));
    const aboveCompatibleText = computed(() => {
      const priceDiff = taxState.value
        ? getPriceWithCurrency(props.altProduct.price_difference_incl_tax)
        : getPriceWithCurrency(props.altProduct.price_difference);

      // If cheaper and higher capacity
      if (props.altProduct.arrow_rule === 1) {
        return app.i18n.t('Print {yieldDiff}% more and save {priceDiff}', { priceDiff, yieldDiff: props.altProduct.yields_difference });
      }
      // If higher capacity, but more expensive
      if (props.altProduct.arrow_rule === 2) {
        return app.i18n.t('Print {yieldDiff}% more for {priceDiff}', { priceDiff, yieldDiff: props.altProduct.yields_difference });
      }
      // All else cases
      if (props.altProduct.arrow_rule === 3) {
        return app.i18n.t('Save {priceDiff}', { priceDiff });
      }

      return '';
    });

    return {
      isProductGenuine,
      productType,
      vatLabel,
      title,
      isAllowedRule,
      aboveCompatibleText,
      price,
      getProductPath,
    };
  },
});
